<template>
  <div class="item-box-content mainStep" style="min-height:632px">
    <div>
      <el-row>
        <el-col :span="12">
          <div class="title-font-style">
            <span>物流管理</span>
          </div>
        </el-col>
        <el-col v-show="isShow" :span="12">
          <div style="text-align:right;">
            <el-button type="text" @click="returnList">
              <i class="el-icon-arrow-left"></i>返回列表
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div v-show="!isShow">
      <el-row style="margin:14px 0">
        <el-col :span="12" class="title">出库单</el-col>
        <el-col :span="12" style="text-align: right">
          <el-button type="primary" :disabled="!addOutboundState" @click="addOutbound">新建出库单</el-button>
        </el-col>
      </el-row>
      <el-table
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column label="出库单编号">
          <template slot-scope="scope">
            <div class="approval" @click="numberDetail(scope.row)">{{ scope.row.outStockNumber}}</div>
          </template>
        </el-table-column>
        <el-table-column label="配送方式">
          <template slot-scope="scope">{{scope.row.deliverType}}</template>
        </el-table-column>
        <el-table-column label="发起人">
          <template slot-scope="scope">{{scope.row.createUser}}</template>
        </el-table-column>
        <el-table-column label="发起时间">
          <template slot-scope="scope">{{scope.row.createDate}}</template>
        </el-table-column>
        <el-table-column label="出货状态">
          <template slot-scope="scope">{{stateFilter[scope.row.state-4]}}</template>
        </el-table-column>
        <el-table-column label="处理人">
          <template slot-scope="scope">{{scope.row.processUser}}</template>
        </el-table-column>
        <el-table-column label="处理时间">
          <template slot-scope="scope">{{scope.row.updateDate}}</template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="isShow">
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="出库单：">{{paramsDetail.outStockNumber}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在仓库：">{{paramsDetail.storageName}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：">{{paramsDetail.storagePhone}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="仓库地址：">{{paramsDetail.storageAddress}}</el-form-item>
          </el-col>
          <div class="title-second">发货信息：</div>
        </el-row>
        <el-row :gutter="20" style="margin-top:20px;">
          <el-col :span="12">
            <el-form-item label="配送方式：">{{paramsDetail.deliverType}}</el-form-item>
          </el-col>
          <el-col :span="12" v-show="status ===1">
            <el-form-item label="物流费用：">{{paramsDetail.logisticCost}}</el-form-item>
          </el-col>
          <el-col :span="24" v-show="status ===1||status ===3">
            <el-form-item label="备注：">{{paramsDetail.mark}}</el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="仓库地址：">{{111111111111111}}</el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="20" style="margin-top:20px;" v-show="status !==2">
          <el-col :span="12">
            <el-form-item label="发货人：">{{paramsDetail.consigner}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：">{{paramsDetail.consignerPhone}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收货人：">{{paramsDetail.consignee}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：">{{paramsDetail.consigneePhone}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收货地址：">{{paramsDetail.consigneeAddress}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-show="statusList === 1">
        <el-steps align-center :active="2" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="填写出库单" icon="el-icon-success"></el-step>
          <el-step title="待出库" icon="el-icon-success"></el-step>
          <el-step title="已出库" icon="el-icon-success"></el-step>
        </el-steps>
      </div>
      <div v-show="statusList === 2">
        <el-steps align-center :active="3" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="填写出库单" icon="el-icon-success"></el-step>
          <el-step title="待出库" icon="el-icon-success"></el-step>
          <el-step title="已出库" icon="el-icon-success"></el-step>
        </el-steps>
      </div>
      <div v-show="statusList === 4">
        <el-steps align-center :active="3" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="填写出库单" icon="el-icon-success"></el-step>
          <el-step title="待出库" icon="el-icon-success"></el-step>
          <el-step title="已作废" icon="el-icon-success"></el-step>
        </el-steps>
      </div>
      <el-table
        border
        ref="tableRef"
        :data="paramsDetail.retreatLogisticProductVos"
        max-height="378"
        tooltip-effect="dark"
        style="margin-top:10px;"
        :header-cell-style="tableHeader"
      >
        <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proModel" label="型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proOrdernum" label="订货号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proUnit" label="单位"></el-table-column>
        <el-table-column show-overflow-tooltip prop="count" label="数量"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderNumber" label="序列号">
          <template slot-scope="scope">
            <el-button type="text" @click="onSee(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="title-second" style="margin-top:20px;">物流信息：</div>
      <!-- v-show="'物流-已出库'" -->
      <div v-if="status ===1 &&statusList !== 1&&statusList !== 4">
        <el-form class="details-line-height" style="padding:20px 30px 0 30px">
          <el-row :gutter="20">
            <div v-for="item in paramsDetail.storageOutstockDeliverLogisticCustoms" :key="item.id">
              <el-col :span="12">
                <el-form-item
                  label="物流公司："
                >{{item.logicCompany}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="物流单号：">
                  <div class="over-text" :title="item.logicNumber" >{{item.logicNumber}}</div>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="12">
              <el-form-item label="处理人：">{{paramsDetail.processUser}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发货时间：">{{paramsDetail.updateDate}}</el-form-item>
            </el-col>
            <!-- v-show="'物流-已出库-有报缺'" -->
            <!-- <div v-show="statusList == 3">
              <el-col :span="24">
                <el-form-item label="报缺备注：">{{"上海市嘉定区金园8路"}}</el-form-item>
              </el-col>
              <el-col :span="24" style="color:#ff2626;">
                <el-form-item label-width="0">{{"确实产品已经打回待入库产品列表,可重新填写反反库信息"}}</el-form-item>
              </el-col>
            </div>-->
          </el-row>
        </el-form>
      </div>
      <!-- v-show="'物流-待出库'" -->
      <div v-show="status ===1 &&statusList === 1" style="padding:20px 30px 20px 30px;">
        暂未查询到物流信息。
        <br />
        <br />您的商品正在出库中，请耐心等待发货。
      </div>

      <div v-show="statusList === 4">
        <el-form class="details-line-height" style="padding:20px 30px 0 30px">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="发货结果：">
                <span style="color:#ff2626;">{{"出库单已作废"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理人：">{{paramsDetail.processUser}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="作废时间：">{{paramsDetail.updateDate}}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div
        v-show="status ===2 &&statusList === 1"
        style="padding:20px 30px 20px 30px;"
      >供应商自提时请携带生成后的退货出库单,交予仓储核验提货;</div>
      <div v-show="status ===2 &&(statusList === 2||statusList === 3)">
        <el-form class="details-line-height" style="padding:20px 30px 0 30px">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label-width="0">{{"供应商已自提,完成发货"}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理人：">{{paramsDetail.processUser}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发货时间：">{{paramsDetail.updateDate}}</el-form-item>
            </el-col>
            <!-- v-show="'物流-已出库-有报缺'" -->
            <!-- <div v-show="statusList == 3">
              <el-col :span="24">
                <el-form-item label="报缺备注：">{{"上海市嘉定区金园8路"}}</el-form-item>
              </el-col>
              <el-col :span="24" style="color:#ff2626;">
                <el-form-item label-width="0">{{"确实产品已经打回待入库产品列表,可重新填写反反库信息"}}</el-form-item>
              </el-col>
            </div>-->
          </el-row>
        </el-form>
      </div>
      <div
        v-show="status ===3 &&statusList === 1"
        style="padding:20px 30px 20px 30px;"
      >您的商品正在出库中，请耐心等待发货。</div>
      <div v-show="status ===3 &&(statusList === 2||statusList === 3)">
        <el-form class="details-line-height" style="padding:20px 30px 0 30px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label-width="0">{{"仓库已发货"}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发货信息：">{{paramsDetail.outMark}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理人：">{{paramsDetail.processUser}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发货时间：">{{paramsDetail.updateDate}}</el-form-item>
            </el-col>
            <!-- v-show="'物流-已出库-有报缺'" -->
            <!-- <div v-show="statusList == 3">
              <el-col :span="24">
                <el-form-item label="报缺备注：">{{"上海市嘉定区金园8路"}}</el-form-item>
              </el-col>
              <el-col :span="24" style="color:#ff2626;">
                <el-form-item label-width="0">{{"确实产品已经打回待入库产品列表,可重新填写反反库信息"}}</el-form-item>
              </el-col>
            </div>-->
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- --------------------待入库 查看序列号侧边栏---------------------- -->
    <see-shipment ref="seeShipmentRefs"></see-shipment>
    <!-- 新建出库单 -->
    <add-outbound-drawer @onFresh="onFresh" ref="addOutboundDrawerRefs"></add-outbound-drawer>
  </div>
</template>
<script>
import logisticsSliderVue from './logisticsStorge'

import {
  queryRetreatLogistic, queryRetreatLogisticDetails
} from '@/api/purchase/purchasePlanList'
import addOutboundDrawer from './addOutboundDrawer'
export default {
  components: {
    'add-outbound-drawer': addOutboundDrawer,
    'see-shipment': logisticsSliderVue

  },
  data () {
    return {
      list: [],
      stateFilter: ['待发货', '已发货', '已下单,快递未揽件', '已作废'],
      isShow: false,
      status: 3, // (1物流快递2供应商自提3仓库配送)
      statusList: 4, // (12已发货4作废)
      state: ['物流配送待出库', '物流配送已出库无报缺', '物流配送待出库有报缺', '物流已作废', '供应商自提待出库', '供应商自提已出库无报缺', '供应商自提待出库有报缺', '供应商自提已作废', '仓库配送待出库', '仓库配送已出库无报缺', '仓库配送待出库有报缺', '仓库配送已作废'],
      dataList: [],
      addOutboundState: false, // 是否可以新建出库单
      suId: '',
      paramsDetail: {}
    }
  },
  mounted () { },
  methods: {
    onSee (row) {
      this.$refs.seeShipmentRefs.onInitialize(row)
    },
    onFresh () {
      this.getList()
    },
    getList () {
      this.isShow = false
      queryRetreatLogistic(this.$route.query.pcrId).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.obj.retreatLogisticManageVo.retreatStorageOutStockVoList
          this.addOutboundState = res.data.obj.retreatLogisticManageVo.isState
          this.suId = res.data.obj.purchaseRetreatVo.suId
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    returnList () {
      this.isShow = false
    },
    numberDetail (row) {
      queryRetreatLogisticDetails(row.pcrlId).then((res) => {
        if (res.data.code === 200) {
          this.paramsDetail = res.data.obj.retreatLogisticDetailsAllVo
          if (this.paramsDetail.deliverType === '快递配送' || this.paramsDetail.deliverType === '物流配送') {
            this.status = 1
          } else if (this.paramsDetail.deliverType === '供应商自提') {
            this.status = 2
          } else if (this.paramsDetail.deliverType === '仓库配送') {
            this.status = 3
          }
          if (this.paramsDetail.state === 4) {
            this.statusList = 1
          } else if (this.paramsDetail.state === 5) {
            this.statusList = 2
          } else if (this.paramsDetail.state === 7) {
            this.statusList = 4
          }
        }
      })
        .catch((err) => {
          console.log(err)
        })
      this.isShow = true
    },
    // 新建出库单
    addOutbound () {
      this.$refs.addOutboundDrawerRefs.onInitialize(this.suId)
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.over-text{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.title {
  font-size: 16px;
  font-weight: 500;
  color: #4e555b;
  line-height: 24px;
  padding-left: 30px;
}
.title-second {
  font-size: 16px;
  font-weight: 600;
  color: #4e555b;
  line-height: 24px;
  padding-left: 10px;
}
</style>
